const en = {
  coreLoginPanel: {
    sso: {
      loginButtonText: 'Login via SSO',
      toolTipText:
        'SSO - authorization system for students and employees of Wroclaw University of Science and Technology'
    },
    local: {
      passwordText: 'Password',
      loginText: 'Username',
      submitButtonText: 'Login'
    },
    backToHomeText: 'Back',
    dividerText: 'or',
    validation: {
      field: 'Field'
    }
  }
};

export default en;
